/* import __COLOCATED_TEMPLATE__ from './duplicate-bot-loading-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();